import { CoreProvider } from '@bees-web/core/shared/contexts'
import { useRouter } from 'next/router'
import { FC, useCallback, useMemo } from 'react'
import { SWRConfig } from 'swr'

import LoginErrorNotification from '@/core/auth/loginError/components/LoginErrorNotification'

import { PageProps } from '../types/interfaces'

import MetaPage from './MetaPage'
import PageContent, { PageContentProps } from './PageContent'

export interface ClientPageProps extends PageContentProps, PageProps {}

const HTTP_UNAUTHORIZED = 401

const Page: FC<ClientPageProps> = ({ serverCache, ...props }) => {
  const { workspace, dependencies } = props

  const router = useRouter()

  const onSwrError = useCallback(
    (error: any) => {
      if (error.response) {
        const { status, data, headers } = error.response
        console.log(data, status, headers)
        if (status === HTTP_UNAUTHORIZED) {
          const [path, qs] = router.asPath.split('?')
          const queryString = qs ? `&${qs}` : ''
          router.push(`/login?redirect_path=${path}${queryString}`)
        }
      } else if (error.request) {
        console.log(error.request)
      } else {
        console.log('Error', error.message)
      }
      console.log(error.config)
    },
    [router]
  )

  const swrValue = useMemo(
    () => ({
      fallback: serverCache ?? {},
      revalidateIfStale: false,
      errorRetryCount: 5,
      errorRetryInterval: 10000,
      dedupingInterval: 60000,
      revalidateOnFocus: false,
      onError: onSwrError,
    }),
    [serverCache, onSwrError]
  )

  return (
    <SWRConfig value={swrValue}>
      <CoreProvider {...props.context}>
        <MetaPage>
          <LoginErrorNotification pageKey={props.context.page.key} />
          <PageContent workspace={workspace} dependencies={dependencies} />
        </MetaPage>
      </CoreProvider>
    </SWRConfig>
  )
}

export default Page
